export default __webpack_public_path__ + "static/media/theme-dark.c4a8113b.svg";